import Content from "./Content";
import Operate from "./Operate";
import Comment from "./Comment";
import { TrendItem } from "@/config/types/trend";
import PicSwiper from "./PicSwiper";
// import { JobItem } from "@/config/types/job";

export default function Picture({
  data,
}: // jobList,
// total,
// openAppTrendDetail,
{
  data: TrendItem;
  // jobList: JobItem[];
  // total: number;
  // openAppTrendDetail: () => void;
}) {
  return (
    <div className="picture-wrap">
      <PicSwiper data={data} />
      <Content theme="light" data={data} />
      <Operate theme="light" data={data} />
      <Comment theme="light" />
    </div>
  );
}
